// extracted by mini-css-extract-plugin
export default {"wrapper":"job-opening-list-block-module--wrapper--63b40"};